/**
 * E2E-only marketing dataLayer stub (no gtm.js).
 *
 * Playwright builds use Vite mode `e2e` without `VITE_GTM_CONTAINER_ID` so
 * real Google tags never load. When `VITE_E2E_MARKETING_DATALAYER` is true,
 * `marketingTracking` still pushes conversion events onto `window.dataLayer`
 * so journeys can assert the SPA contract without contacting Google.
 */

/** Vite env flag — must be `true` or `1` in `.env.e2e` / CI build env. */
export const VITE_E2E_MARKETING_DATALAYER = 'VITE_E2E_MARKETING_DATALAYER';

/**
 * Sentinel container id returned by getGtmContainerId when the E2E stub is on.
 * Never injected by vite-plugin-gtm (production-only + real GTM-XXXX pattern).
 */
export const E2E_MARKETING_DATALAYER_STUB_CONTAINER_ID = 'GTM-E2ESTUB';
